import { axiosInstance, updateAuthToken } from './axiosinterceptor';

class DataService {
  constructor() {
    this.axiosInstance = axiosInstance;
  }

  async getData(url) {
    try {
      updateAuthToken();
      const response = await this.axiosInstance.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async postData(url, data) {
    try {
      updateAuthToken();
      const response = await this.axiosInstance.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new DataService();
